<ng-content select="[prefix-icon]"></ng-content>
<span><ng-content></ng-content></span>
<ng-content select="[suffix-icon]"></ng-content>
